module.exports = __webpack_public_path__ + "static/media/data-security.2124bdaf.svg";